import React, { useState, useEffect } from "react";
import "./AboutUs.css";
import Navbar from "../MainComponents/Navbar";
import Footer from "../MainComponents/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AboutUs() {
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.05,
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-stagger, .skills-section"
    );
    revealElements.forEach((el) => observer.observe(el));

    return () => {
      revealElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="about-page">
      <Navbar />

      {/* HERO SECTION */}
      <div className={`about-content ${isLoaded ? "animate-in" : ""}`}>
        <h1>{t('about.title')}</h1>
        <div className="breadcrumb">
          <span>{t('about.home')}</span>
          <span className="arrow">›</span>
          <span>{t('about.title')}</span>
        </div>
      </div>

      {/* ABOUT SECTION */}
      <div className="about-section">
        <div className="about-image reveal-left">
          <img
            src="https://images.pexels.com/photos/4252139/pexels-photo-4252139.jpeg"
            alt="chef"
          />
        </div>

        <div className="about-text reveal-right">
          <p className="small-title">
            {t('about.smallTitle')}
          </p>
          <h2>
            {t('about.weAlwaysMakeBest')}
          </h2>
          <p className="description">
            {t('about.description')}
          </p>
          <Link to="/contact" className="contact-btn">{t('about.contactUs')}</Link>
        </div>
      </div>

      {/* SKILLS SECTION */}
      <div className="skills-section">
        <div className="skills-left reveal-left">
          <h2>{t('about.ourSkills')}</h2>
          <p className="skills-description">
            {t('about.skillsDescription')}
          </p>

          <div className="skill">
            <div className="skill-title">
              <span>{t('about.reliability')}</span>
              <span>95%</span>
            </div>
            <div className="skill-bar">
              <div className="skill-fill fill1"></div>
            </div>
          </div>

          <div className="skill">
            <div className="skill-title">
              <span>{t('about.selection')}</span>
              <span>88%</span>
            </div>
            <div className="skill-bar">
              <div className="skill-fill fill2"></div>
            </div>
          </div>

          <div className="skill">
            <div className="skill-title">
              <span>{t('about.speed')}</span>
              <span>92%</span>
            </div>
            <div className="skill-bar">
              <div className="skill-fill fill3"></div>
            </div>
          </div>
        </div>

        <div className="skills-right reveal-stagger">
          <div className="stat-box">
            <h1>20+</h1>
            <p>{t('about.yearsOfExperience')}</p>
          </div>
          <div className="stat-box">
            <h1>1,000+</h1>
            <p>{t('about.partners')}</p>
          </div>
          <div className="stat-box">
            <h1>300k+</h1>
            <p>{t('about.happyCustomers')}</p>
          </div>
          <div className="stat-box">
            <h1>64</h1>
            <p>{t('about.certifiedAward')}</p>
          </div>
        </div>
      </div>

      {/* DELIVERY SECTION */}
      <div className="delivery-section">
        <div className="delivery-overlay reveal-scale">
          <p className="delivery-small-title">
            {t('about.hireUsNow')}
          </p>
          <h1 className="delivery-title">
            {t('about.alwaysReady')}
          </h1>
          <Link to="/signup" className="delivery-btn">{t('about.getStarted')}</Link>
        </div>
      </div>

      {/* FOOTER SECTION */}
      <Footer />
    </div>
  );
}

export default AboutUs;